import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { SectionInner } from '../components/SectionInner';
import { CornerFrame } from '../components/CornerFrame';
import { CoChairs } from './CoChairs';

export function WhyForum() {
  const { whyForum } = conventionContent;
  return (
    <Box
      component="section"
      id={whyForum.sectionId}
      aria-labelledby={whyForum.headingId}
    >
      <CoChairs />
      <Box
        sx={{
          backgroundColor: 'background.default',
          paddingBlock: { mobile: pxToRem(48), laptop: pxToRem(120) },
        }}
      >
        <SectionInner
        direction={{ mobile: 'column', laptop: 'row' }}
        gap={{ mobile: pxToRem(48), laptop: pxToRem(128) }}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: { mobile: pxToRem(300), laptop: pxToRem(256) },
            height: { mobile: pxToRem(304.528), laptop: pxToRem(475) },
            flexShrink: 0,
          }}
        >
          <CornerFrame
            corner="top-left"
            inset={{
              mobile: { horizontal: 17.466, vertical: 26 },
              laptop: { horizontal: 19, vertical: 26 },
            }}
            radius={{ mobile: 29, laptop: 28 }}
          />
          <Stack
            gap={{ mobile: pxToRem(24), laptop: pxToRem(64) }}
            sx={{
              position: 'absolute',
              top: { mobile: pxToRem(46), laptop: pxToRem(49) },
              left: { mobile: '50%', laptop: pxToRem(44) },
              transform: { mobile: 'translateX(-50%)', laptop: 'none' },
              width: { mobile: pxToRem(255), laptop: pxToRem(212) },
              alignItems: { mobile: 'center', laptop: 'flex-start' },
              textAlign: { mobile: 'center', laptop: 'left' },
            }}
          >
            <Stack gap={pxToRem(24)} sx={{ width: '100%', color: 'primary.main' }}>
              <Typography
                component="h2"
                id={whyForum.headingId}
                variant="h2"
                sx={{
                  fontSize: { mobile: pxToRem(24), laptop: pxToRem(32) },
                  lineHeight: { mobile: pxToRem(32), laptop: pxToRem(40) },
                  margin: 0,
                }}
              >
                <Box component="span" sx={{ display: { mobile: 'none', laptop: 'block' } }}>
                  {whyForum.headingLines.map((line, i) => (
                    <Box component="span" key={i} sx={{ display: 'block' }}>
                      {line}
                    </Box>
                  ))}
                </Box>
                <Box component="span" sx={{ display: { mobile: 'block', laptop: 'none' } }}>
                  {whyForum.headingLinesMobile.map((line, i) => (
                    <Box component="span" key={i} sx={{ display: 'block' }}>
                      {line}
                    </Box>
                  ))}
                </Box>
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Roboto", sans-serif',
                  fontWeight: 700,
                  fontSize: { mobile: pxToRem(16), laptop: pxToRem(18) },
                  lineHeight: pxToRem(20),
                  margin: 0,
                }}
              >
                {whyForum.subtitle}
              </Typography>
            </Stack>
            <Typography
              sx={{
                fontFamily: '"Roboto", sans-serif',
                fontWeight: 700,
                fontSize: { mobile: pxToRem(16), laptop: pxToRem(20) },
                lineHeight: pxToRem(24),
                color: 'secondary.main',
                margin: 0,
              }}
            >
              {whyForum.accent}
            </Typography>
          </Stack>
        </Box>
        <Stack
          direction={{ mobile: 'column', laptop: 'row' }}
          gap={{ mobile: pxToRem(60), laptop: pxToRem(128) }}
          sx={{
            width: { mobile: pxToRem(297), laptop: pxToRem(736) },
            alignItems: { mobile: 'center', laptop: 'flex-start' },
          }}
        >
          {whyForum.cards.map((card, index) => (
            <Stack
              key={index}
              gap={pxToRem(24)}
              sx={{
                width: { mobile: '100%', laptop: pxToRem(160) },
                alignItems: { mobile: 'center', laptop: 'flex-start' },
                textAlign: { mobile: 'center', laptop: 'left' },
                color: 'primary.main',
              }}
            >
              <Box
                component="img"
                src={card.iconSrc}
                alt={card.iconAlt}
                aria-hidden="true"
                sx={{
                  width: pxToRem(160),
                  height: pxToRem(160),
                  display: 'block',
                  objectFit: 'contain',
                }}
              />
              <Stack gap={0}>
                <Typography
                  component="p"
                  sx={{
                    fontFamily: '"Roboto", sans-serif',
                    fontWeight: 900,
                    fontSize: { mobile: pxToRem(14), laptop: pxToRem(16) },
                    lineHeight: pxToRem(20),
                    margin: 0,
                  }}
                >
                  {card.title}
                </Typography>
                <Typography
                  component="p"
                  sx={{
                    fontFamily: '"Roboto", sans-serif',
                    fontWeight: 400,
                    fontSize: { mobile: pxToRem(14), laptop: pxToRem(16) },
                    lineHeight: pxToRem(20),
                    margin: 0,
                  }}
                >
                  {card.body}
                </Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
        </SectionInner>
      </Box>
    </Box>
  );
}
